import { Inject, Injectable } from '@angular/core';
import { DwCacheService, DwEventService, DwFormControlSearchLookupComponent, DwLookupUtilService, DwMetaDataService, DwMetaDataServiceToken, DwOrmDataService, DwOrmDataServiceToken, DwQueryFilter, DwQueryHelper } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';
import { CodeValuePermitType, PermitEntity, PermitPermitTypeEntity, PermitRequestPermitTypeEntity, PermitsMetaDataService } from '../meta-data/permits-meta-data.service';

@Injectable({  providedIn: 'root' })
export class PermitService {

  
  constructor(
    @Inject(DwOrmDataServiceToken) private dwOrmDataService: DwOrmDataService,
    @Inject(DwMetaDataServiceToken) private dwMetaDataService: DwMetaDataService,
    private dwEventsService: DwEventService,
    private dwCacheService: DwCacheService,
) {
}

  /**
   * Creates a new permit and returns the created permit object..
   * @param data PermitEntity type 
   * @returns created permit
   */
  
  createPermit(data: PermitEntity){ 
    const md = new PermitsMetaDataService();
    return this.dwOrmDataService.saveEntity(data, true);
  } 

  createPermits(data: PermitEntity[]){ 
    return this.dwOrmDataService.saveEntityCollection(data, false);
  } 
  createPermitPermitTypes(data: PermitPermitTypeEntity[]): Observable<PermitPermitTypeEntity[]>{ 
    return this.dwOrmDataService.saveEntityCollection(data, false);
  } 


  getPermitTypeCodeValues(){
    const md = new AppMetaDataService();
    const filter: DwQueryFilter = new DwQueryFilter(); 
    filter.Attr = md.EthosCodeValue.CodeSetId
    filter.Value = "493";
    const query = md.EthosCodeValue.CreateQuery().AddFilterAnd(filter);
    let data = this.dwOrmDataService.executeQuery(query);
    return data;
  }

  getPermitsByPermitRequestId(permitRequestId: string):Observable<PermitEntity[]> {
    const md  = new PermitsMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.Permit.CreateQuery();
    
    query.AddFilterAnd(qh.filters.Equal(md.Permit.PermitRequestid, permitRequestId));
    
    query.AddPrefetchPath(md.Permit.Relations.PermitPermitType);
    
    let data = this.dwOrmDataService.executeQuery(query)    
    return data; 
  }

  
  getPermitsTypesFromPermit(permitRequestId: number):Observable<PermitPermitTypeEntity[]> {
    const md  = new PermitsMetaDataService();
    const qh = new DwQueryHelper();

    const query = md.PermitPermitType.CreateQuery();
    
    // Join to permit
    query.AddRelation(md.PermitPermitType.Relations.Permit);

    // filter on permit.PermitRequest
    query.AddFilterAnd(qh.filters.Equal(md.Permit.PermitRequestid, permitRequestId));
    
    let data = this.dwOrmDataService.executeQuery(query)    
    return data; 
  }


  getPermitRequestPermitTypesByPermitRequestId(permitRequestId: string) :Observable<PermitRequestPermitTypeEntity[]>{
    const md  = new PermitsMetaDataService();
    const qh = new DwQueryHelper();

    const filter: DwQueryFilter = new DwQueryFilter();
    filter.Attr = md.PermitRequestPermitType.PermitRequestId; 
    filter.Value = permitRequestId; 
    const query = md.PermitRequestPermitType .CreateQuery().AddFilterAnd(filter);
    let data = this.dwOrmDataService.executeQuery(query)    
    return data; 
  }


  getPermitPermitTypesByPermitId(permitId: string) :Observable<PermitPermitTypeEntity[]>{
    const md  = new PermitsMetaDataService();
    const qh = new DwQueryHelper();
    const filter: DwQueryFilter = new DwQueryFilter();
    filter.Attr = md.PermitPermitType.PermitId; 
    filter.Value = permitId; 

    const query = md.PermitPermitType.CreateQuery().AddFilterAnd(filter);
    
    let data = this.dwOrmDataService.executeQuery(query)    
    return data; 
  }
  

}

